// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-view-alumni-query',
//   templateUrl: './view-alumni-query.component.html',
//   styleUrls: ['./view-alumni-query.component.scss']
// })
// export class ViewAlumniQueryComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommunicationService } from 'src/app/providers/communication/communication.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { MisReportsService } from 'src/app/providers/mis-reports/mis-reports.service';
import { QueryDashService } from 'src/app/providers/query/query-dash.service';
import { QueryService } from 'src/app/providers/query/query.service';
import { ExcelService } from 'src/app/service/excelService/excel.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
declare let $: any;
@Component({
  selector: 'app-view-alumni-query',
  templateUrl: './view-alumni-query.component.html',
  styleUrls: ['./view-alumni-query.component.scss']
})
export class ViewAlumniQueryComponent implements OnInit {
  @Output() openQuery = new EventEmitter<any>();
  @Input() empId;
  myQueryData: any = [];
  reOpenRemark: string;
  QueryRemark: string;
  public page = 1;
  public count = 0;
  public pageSize = 10;
  public from;
  public to;
  categList: any = [];
  subCategList: any = [];
  subCategstatus: any;
  categListStatus: any;
  searchuser;
  result: any;
  isSearch1 = false;
  searchForms: FormGroup;
  reOpenUserDetailForm: FormGroup;
  commonData: any = {};
  qryStatus: any;
  specificQuery: any = {};
  reOpensubmitted = false;
  getAccType: any;
  getBankName: any;
  Img: any = [];
  filterQuery = {
    queryType: '',
  };
  statusCount$!: Observable<any>;
  constructor(public router: Router,
              private queryServ: QueryService,
              private notifyService: NotificationService,
              private generalServ: GeneralService,
              private excelServ: ExcelService,
              private comm: CommunicationService,
              private misService: MisReportsService,
              public qryDash: QueryDashService) { }

  ngOnInit(): void {
    this.statusCount$ = this.qryDash.statusCount({ myQuery: true});
    this.reOpenRemark = '';
    this.searchForms = new FormGroup({
      costCenters: new FormControl(''),
      cat_id: new FormControl(''),
      sub_cat_id: new FormControl(''),
      query_status: new FormControl(''),
      category: new FormControl(''),
      sub_category: new FormControl(''),
      date_range: new FormControl('logged_by'),
      date_to: new FormControl(''),
      date_from: new FormControl(''),
      qryId: new FormControl(''),
      is_excel: new FormControl(0),
    });
    this.reOpenUserDetailForm = new FormGroup({
      acc_type: new FormControl(''),
      bank_id: new FormControl(''),
      acc_no: new FormControl(''),
      ifsc_code: new FormControl(''),
      reOpenRemark: new FormControl('', [Validators.required]),
      doc: new FormControl(''),
    });
    this.comm.receiveMsg().subscribe((res) => {
      console.log(res);
    });
    this.searchForms.patchValue({
      is_excel: 0
    });
    this.myQueryMaster();
    this.getQueryStatus();
    this.getQueryCategory();

    this.comm.receiveMsg().subscribe((res) => {
      if (res.type === 'REFRESH_MY_QUERY') {
        this.myQueryMaster();
      }
    });

  }

  get reOpenUserDetailCont(): any {
    return this.reOpenUserDetailForm.controls;
  }

  openReportModal(id): void {
    $(id).modal('show');
  }

  closeModals(): void {
    $('#query_report_modal').modal('hide');
  }

  onSubmitFormQuery(): void {
    const params = {
      ...this.filterQuery
    };
    this.misService.downloadQueryMaster(params).subscribe(res => {
      if (res.status) {
        window.open(res.url, '_blank');
      } else {
        this.notifyService.showError('Internal server error!');
      }
    },
      err => {
        this.notifyService.showError('Internal server error!');
      });
  }// end of function


  getQueryStatus(): void {
    this.queryServ.getQueryStatus().subscribe(res => {
      this.result = res;
      if (this.result.status) {
        this.qryStatus = this.result.data;
      } else {
        this.qryStatus = [];
      }
    }, err => {
      this.notifyService.showError('Internal Server Error', 'Error!');
    });
  }

  handlePageChange(event): void {
    this.searchForms.patchValue({
      is_excel: 0
    });
    this.page = event;
    this.myQueryMaster();
  }

  getNumberPerPage(event): void {
    this.searchForms.patchValue({
      is_excel: 0
    });
    this.pageSize = event.target.value;
    this.myQueryMaster();
  }

  myQueryMaster(): void {
    this.commonData = {
        ...this.searchForms.value,
        limit: this.pageSize,
        page: this.page,
        empId: this.empId
      };
    this.queryServ.getMyQueryMaster(this.commonData).subscribe((data) => {
      if (data['status']){
        this.myQueryData = data['data'].data;
        this.count = data.data.total;
        this.from = data.data.from;
        this.to = data.data.to;

        console.log(this.count);
      }else{
        this.myQueryData = [];
      }
    });
  }

  editQuery(data): void {
    console.log(data);
    // this.router.navigate(['/queries/edit/' + data.qry_id]);
    const res = { ...data, editType: 'MY' };
    this.openQuery.emit(res);

  }

  onSubmit(): void {
    this.searchForms.patchValue({
      is_excel: 0
    });
    this.myQueryMaster();
  }

  exportExcel(): void {
    this.searchForms.patchValue({
      is_excel: 1
    });
    this.commonData = {
      ...this.searchForms.value,
      limit: this.pageSize,
      page: this.page,
    };
    this.queryServ.getMyQueryMaster(this.commonData).subscribe((data) => {
        const reportData = {
          title: 'My Queries',
          data: Object.values(data.excel_data),
          headers: Object.values(data.header)
        };
        this.excelServ.exportAttendanceExcel(reportData);
        this.searchForms.patchValue({
          is_excel: 0,
        });
    });
    // this.myQueryMaster(this.commonData);
  }

  onChangeCategory(event): void {
    this.getGeneralSubCategory(event.target.value);
  }
  getGeneralSubCategory(subCategID): void {
    this.subCategList = [];
    const temp = {
      cat_id: subCategID,
      status: 1
    };
    this.queryServ.getSubCategory(temp).subscribe(res => {
      this.subCategstatus = res;
      if (this.subCategstatus.status) {
        this.subCategList = this.subCategstatus.data;
      } else {
        this.notifyService.showInfo(this.subCategstatus.msg, 'Info!');
      }
    }, err => {
      this.notifyService.showError('Internal Server Error', 'Error!');
    });
  }

  getQueryCategory(): void {
    this.queryServ.getCategory().subscribe(res => {
      this.categListStatus = res;
      if (this.categListStatus.status) {
        this.categList = this.categListStatus.data;
      } else {
        this.notifyService.showInfo(this.categListStatus.msg, 'Info!');
      }
    }, err => {
      this.notifyService.showError('Internal Server Error', 'Error!');
    });
  }

  openReOpenModal(data): void {
    this.editQuery(data);
    return;
    this.reOpensubmitted = true;
    this.specificQuery = data;
    this.reOpenRemark = '';
    this.QueryRemark = data.qry_desc;
    if (data.subcat1_id === '7' || data.subcat1_id === 7){

      this.queryServ.queryUserDetails(data.qry_id).subscribe((res) => {
        if (res.status){
          const dataz = res.data;
          this.reOpenUserDetailForm.patchValue({
            acc_type: dataz.acc_type,
            bank_id: dataz.bnk_id,
            acc_no: dataz.acc_no,
            ifsc_code: dataz.ifsc
          });
        }

      });
      this.reOpenUserDetailForm.get('acc_no').setValidators([
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12),
        Validators.pattern('^[0-9]*$')]);
      this.reOpenUserDetailForm.get('acc_no').updateValueAndValidity();
      this.reOpenUserDetailForm.get('acc_type').setValidators([Validators.required]);
      this.reOpenUserDetailForm.get('acc_type').updateValueAndValidity();
      this.reOpenUserDetailForm.get('bank_id').setValidators([Validators.required]);
      this.reOpenUserDetailForm.get('bank_id').updateValueAndValidity();
      this.reOpenUserDetailForm.get('ifsc_code').setValidators([Validators.required]);
      this.reOpenUserDetailForm.get('ifsc_code').updateValueAndValidity();
      this.getBanks();
      this.getAccountTypes();
    } else {

      this.reOpenUserDetailForm.get('acc_no').clearValidators();
      this.reOpenUserDetailForm.get('acc_no').updateValueAndValidity();
      this.reOpenUserDetailForm.get('acc_type').clearValidators();
      this.reOpenUserDetailForm.get('acc_type').updateValueAndValidity();
      this.reOpenUserDetailForm.get('bank_id').clearValidators();
      this.reOpenUserDetailForm.get('bank_id').updateValueAndValidity();
      this.reOpenUserDetailForm.get('ifsc_code').clearValidators();
      this.reOpenUserDetailForm.get('ifsc_code').updateValueAndValidity();

    }
    console.log(data);
    $('#reopenModal').modal('show');
  }

  getBanks(): void {
    this.generalServ.getBanks().subscribe(res => {
      this.result = res;
      this.getBankName = this.result.data;
    });
  }
  getAccountTypes(): void {
    this.generalServ.getAccountTypes().subscribe(res => {
      this.result = res;
      this.getAccType = this.result.data;
    });
  }

  reopenQuery(): void {

    if (this.reOpenUserDetailForm.invalid){
      return;
    }

    // const data = {
    //   ...this.reOpenUserDetailForm.value,
    //   qry_id: this.specificQuery.qry_id
    // };

    const form = new FormData();
    form.append('acc_type', this.reOpenUserDetailForm.get('acc_type').value);
    form.append('bank_id', this.reOpenUserDetailForm.get('bank_id').value);
    form.append('acc_no', this.reOpenUserDetailForm.get('acc_no').value);
    form.append('ifsc_code', this.reOpenUserDetailForm.get('ifsc_code').value);
    form.append('reOpenRemark', this.reOpenUserDetailForm.get('reOpenRemark').value);
    form.append('img[]', this.Img);
    form.append('qry_id', this.specificQuery.qry_id);
    this.queryServ.reopenQuery(form)
    .subscribe((res) => {
      if (res.status){
        this.editQuery(this.specificQuery);
        this.specificQuery.stage_id = 5;
        this.specificQuery.stage_desc = 'Reopen';
        this.specificQuery.rslv_date = '0000-00-00 00:00:00';
        $('#reopenModal').modal('hide');
        this.notifyService.showSuccess(res.msg, 'Success!');
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }

  onCloseModal(): void {
    this.specificQuery = {};
    this.reOpenRemark = '';
    $('#reopenModal').modal('hide');
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.Img = file;
    }
  }

}
